import { required } from 'vuelidate/lib/validators'

export default {
  registration: {
    document: {
      required
    },
    state: {
      required
    },
    record: {
      required
    },
    name: {
      required
    },
    birthdate: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/record/registration/resources/validations.js